// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconDocument.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconDocument = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M9.5 0H3.5C2.675 0 2 0.72 2 1.6V14.4C2 15.28 2.675 16 3.5 16H12.5C13.325 16 14 15.28 14 14.4V4.8L9.5 0ZM12.875 5.6H8.75V1.2L12.875 5.6Z" />
  </BaseIcon>
);

export default IconDocument;
